import React from "react";
import CustomButton, {DangerButton, SecondaryButton} from "../../../components/CustomButton";
import CustomIcon from "../../../components/CustomIcon";
import {TableCell} from "../../../components/table/CustomTable";


export default function AddItemLoader({count = 15}) {
  return (
    <>
      <tbody className="animate-pulse">
      {Array.from({length: count}, (v, k) => <AddItemLoaderItem key={`add-item-loader-${k}`}/>)}
      </tbody>
    </>
  );
}

function AddItemLoaderItem() {
  return (
    <tr>
      <TableCell className="bg-rand-400">
        <div className="h-5 bg-gray-300"/>
      </TableCell>
      <TableCell className="bg-rand-400 w-full">
        <div className="h-5 bg-gray-300 w-full"/>
      </TableCell>
      <TableCell className="bg-rand-400">
        <div className="flex space-x-2 justify-end">
          <SecondaryButton isIconButton={true} className="pointer-events-none">
            <CustomIcon icon="visibility" className="text-gray-300"/>
          </SecondaryButton>
          <SecondaryButton isIconButton={true} className="pointer-events-none">
            <CustomIcon icon="edit" className="text-gray-300"/>
          </SecondaryButton>
          <SecondaryButton isIconButton={true} className="pointer-events-none">
            <CustomIcon icon="delete" className="text-gray-300"/>
          </SecondaryButton>
        </div>
      </TableCell>
    </tr>
  );
}

export function AddItemError({errorMsg, retry}) {
  return (
    <div>
      <div className="text-center text-lg">{errorMsg}</div>
      <div className="text-center mt-20">
        <DangerButton onClick={retry}>Retry</DangerButton>
      </div>

    </div>
  );
}

